import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MessageCircle, MapPin, Mail } from 'lucide-react';

const LOGO_URL =
  'https://customer-assets-rejwkqb3.emergentagent.net/job_6105b58a-7e55-474e-a974-617e58e42c4a/artifacts/q23o4nye_Gemini_Generated_Image_487caf487caf487c.png';

const GOLD = '#C9A84C';

const TikTokIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
  </svg>
);

export default function Footer() {
  const socialLinks = [
    { icon: Instagram, href: 'https://www.instagram.com/aurachocolatesmx/', label: 'Instagram' },
    { icon: Facebook, href: 'https://facebook.com/Aurachocolatesmx', label: 'Facebook' },
    { icon: TikTokIcon, href: 'https://www.tiktok.com/@aurachocolatesmx', label: 'TikTok' },
  ];

  const navLinks = [
    { to: '/', label: 'Inicio' },
    { to: '/caracteristicas', label: 'Características' },
    { to: '/distribuidores', label: 'Distribuidores' },
    { to: '/mixologia', label: 'Mixología' },
    { to: '/contacto', label: 'Contacto' },
  ];

  const contactInfo = [
    { icon: MessageCircle, text: 'WhatsApp: +52 (663) 699 5409', href: 'https://wa.me/526636995409' },
    { icon: MapPin, text: 'República Mexicana', href: null },
    { icon: Mail, text: 'contacto@aurachocolates.com.mx', href: 'mailto:contacto@aurachocolates.com.mx' },
  ];

  return (
    <footer
      style={{
        background: '#060606',
        borderTop: '1px solid rgba(201,168,76,0.15)',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '80rem',
          margin: '0 auto',
          padding: '4rem 1.5rem',
        }}
      >
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
              <img
                src={LOGO_URL}
                alt="Aura"
                style={{ width: '3rem', height: '3rem', borderRadius: '50%', objectFit: 'cover' }}
              />
              <div>
                <div
                  style={{
                    color: GOLD,
                    fontFamily: 'Cormorant Garamond, serif',
                    fontSize: '1.2rem',
                    fontWeight: 600,
                    letterSpacing: '0.3em',
                  }}
                >
                  AURA
                </div>
                <div style={{ color: 'rgba(201,168,76,0.5)', fontSize: '0.58rem', letterSpacing: '0.3em' }}>
                  KING &amp; QUEEN
                </div>
              </div>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.82rem', lineHeight: 1.8, marginBottom: '1.5rem' }}>
              Chocolate afrodisíaco Supreme para despertar energía, deseo y conexión. Disponible en toda la
              República Mexicana.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  style={{
                    width: '2.25rem',
                    height: '2.25rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid rgba(201,168,76,0.25)',
                    color: GOLD,
                    textDecoration: 'none',
                    transition: 'background 0.3s ease, transform 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(201,168,76,0.1)';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4
              style={{
                color: GOLD,
                fontSize: '0.68rem',
                letterSpacing: '0.35em',
                textTransform: 'uppercase',
                fontWeight: 600,
                marginBottom: '1.5rem',
              }}
            >
              Navegación
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    style={{
                      color: 'rgba(255,255,255,0.45)',
                      textDecoration: 'none',
                      fontSize: '0.82rem',
                      transition: 'color 0.25s ease',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = GOLD)}
                    onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.45)')}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              style={{
                color: GOLD,
                fontSize: '0.68rem',
                letterSpacing: '0.35em',
                textTransform: 'uppercase',
                fontWeight: 600,
                marginBottom: '1.5rem',
              }}
            >
              Información
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {contactInfo.map(({ icon: Icon, text, href }, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <Icon size={13} style={{ color: GOLD, flexShrink: 0 }} />
                  {href ? (
                    <a
                      href={href}
                      style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem', textDecoration: 'none' }}
                    >
                      {text}
                    </a>
                  ) : (
                    <span style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem' }}>{text}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid rgba(201,168,76,0.1)',
            paddingTop: '2rem',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem',
          }}
        >
          <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.72rem' }}>
            © 2025 Aura King &amp; Queen · Chocolate Supreme · México
          </p>
          <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.72rem' }}>
            Solo para adultos (+18) · Producto exclusivo
          </p>
        </div>
      </div>
    </footer>
  );
}
